var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverageAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1422 16.2395C14.0358 16.2395 16.3816 13.8937 16.3816 11.0001C16.3816 8.10648 14.0358 5.76074 11.1422 5.76074C8.24857 5.76074 5.90283 8.10648 5.90283 11.0001C5.90283 13.8937 8.24857 16.2395 11.1422 16.2395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M0.865723 11C0.865723 5.32915 5.4732 0.75 11.1423 0.75C15.7492 0.75 19.7564 3.80325 21.0104 8.19196L21.1014 8.51064L20.3699 8.53723L20.3173 8.35753C19.1247 4.28711 15.4182 1.46277 11.1423 1.46277C5.88145 1.46277 1.60508 5.73913 1.60508 11C1.60508 16.2609 5.88145 20.5372 11.1423 20.5372V21.0372L11.1157 21.0372V21.25C5.47276 21.25 0.865723 16.6704 0.865723 11Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 21.1343,
    cy: 11,
    r: 2,
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageAnalysis);
export default __webpack_public_path__ + "static/media/CoverageAnalysis.a6b46284f4c43090f0081fe27f4a7e29.svg";
export { ForwardRef as ReactComponent };